module.exports = __webpack_public_path__ + "img/929.0cc201e9.jpg";